export const RequestTypes = {
	transactionType: 'TransactionType',
	sourceApplication: 'SourceApplication',
	integrationType: 'IntegrationType',
	oem: 'Oem'
};

export const logEntrytransactionTypes = {
	ThirdPartyVendor: 'ThirdPartyVendor',
	Oem: 'OEM',
	VueDmsInternal: 'VueDMSInternal'
};

export const Healths = {
	Success: 'INFO',
	Error: 'ERROR',
	Debug: 'DEBUG'
};
